export enum PagingType {
    Scroll,
    Pager,
    Endless
}
